/* eslint-disable */
const time = {
    time: [{
    label: '00:00',
    value: '00:00~00:30',
    end: '00:30',
    xuanzhong: 0,
    key: 0
  }, {
    label: '00:30',
    value: '00:30~01:00',
    end: '01:00',
    xuanzhong: 0,
    key: 1
  }, {
    label: '01:00',
    value: '01:00~01:30',
    end: '01:30',
    xuanzhong: 0,
    key: 2
  }, {
    label: '01:30',
    value: '01:30~02:00',
    end: '02:00',
    xuanzhong: 0,
    key: 3
  }, {
    label: '02:00',
    value: '02:00~02:30',
    end: '02:30',
    xuanzhong: 0,
    key: 4
  }, {
    label: '02:30',
    value: '02:30~03:00',
    end: '03:00',
    xuanzhong: 0,
    key: 5
  }, {
    label: '03:00',
    value: '03:00~03:30',
    end: '03:30',
    xuanzhong: 0,
    key: 6
  }, {
    label: '03:30',
    value: '03:30~04:00',
    end: '04:00',
    xuanzhong: 0,
    key: 7
  }, {
    label: '04:00',
    value: '04:00~04:30',
    end: '04:30',
    xuanzhong: 0,
    key: 8
  }, {
    label: '04:30',
    value: '04:30~05:00',
    end: '05:00',
    xuanzhong: 0,
    key: 9
  }, {
    label: '05:00',
    value: '05:00~05:30',
    end: '05:30',
    xuanzhong: 0,
    key: 10
  }, {
    label: '05:30',
    value: '05:30~06:00',
    end: '06:00',
    xuanzhong: 0,
    key: 11
  }, {
    label: '06:00',
    value: '06:00~06:30',
    end: '06:30',
    xuanzhong: 0,
    key: 12
  }, {
    label: '06:30',
    value: '06:30~07:00',
    end: '07:00',
    xuanzhong: 0,
    key: 13
  }, {
    label: '7:00',
    value: '7:00~7:30',
    end: '7:30',
    xuanzhong: 0,
    key: 14
  }, {
    label: '7:30',
    value: '7:30~8:00',
    end: '8:00',
    xuanzhong: 0,
    key: 15
  }, {
    label: '8:00',
    value: '8:00~8:30',
    end: '8:30',
    xuanzhong: 0,
    key: 16
  }, {
    label: '8:30',
    value: '8:30~9:00',
    end: '9:00',
    xuanzhong: 0,
    key: 17
  }, {
    label: '9:00',
    value: '9:00~9:30',
    end: '9:30',
    xuanzhong: 0,
    key: 18
  }, {
    label: '9:30',
    value: '9:30~10:00',
    end: '10:00',
    xuanzhong: 0,
    key: 19
  }, {
    label: '10:00',
    value: '10:00~10:30',
    end: '10:30',
    xuanzhong: 0,
    key: 20
  }, {
    label: '10:30',
    value: '10:30~11:00',
    end: '11:00',
    xuanzhong: 0,
    key: 21
  }, {
    label: '11:00',
    value: '11:00~11:30',
    end: '11:30',
    xuanzhong: 0,
    key: 22
  }, {
    label: '11:30',
    value: '11:30~12:00',
    end: '12:00',
    xuanzhong: 0,
    key: 23
  }, {
    label: '12:00',
    value: '12:00~12:30',
    end: '12:30',
    xuanzhong: 0,
    key: 24
  }, {
    label: '12:30',
    value: '12:30~13:00',
    end: '13:00',
    xuanzhong: 0,
    key: 25
  }, {
    label: '13:00',
    value: '13:00~13:30',
    end: '13:30',
    xuanzhong: 0,
    key: 26
  }, {
    label: '13:30',
    value: '13:30~14:00',
    end: '14:00',
    xuanzhong: 0,
    key: 27
  }, {
    label: '14:00',
    value: '14:00~14:30',
    end: '14:30',
    xuanzhong: 0,
    key: 28
  }, {
    label: '14:30',
    value: '14:30~15:00',
    end: '15:00',
    xuanzhong: 0,
    key: 29
  }, {
    label: '15:00',
    value: '15:00~15:30',
    end: '15:30',
    xuanzhong: 0,
    key: 30
  }, {
    label: '15:30',
    value: '15:30~16:00',
    end: '16:00',
    xuanzhong: 0,
    key: 31
  }, {
    label: '16:00',
    value: '16:00~16:30',
    end: '16:30',
    xuanzhong: 0,
    key: 32
  }, {
    label: '16:30',
    value: '16:30~17:00',
    end: '17:00',
    xuanzhong: 0,
    key: 33
  }, {
    label: '17:00',
    value: '17:00~17:30',
    end: '17:30',
    xuanzhong: 0,
    key: 34
  }, {
    label: '17:30',
    value: '17:30~18:00',
    end: '18:00',
    xuanzhong: 0,
    key: 35
  }, {
    label: '18:00',
    value: '18:00~18:30',
    end: '18:30',
    xuanzhong: 0,
    key: 36
  }, {
    label: '18:30',
    value: '18:30~19:00',
    end: '19:00',
    xuanzhong: 0,
    key: 37
  }, {
    label: '19:00',
    value: '19:00~19:30',
    end: '19:30',
    xuanzhong: 0,
    key: 38
  }, {
    label: '19:30',
    value: '19:30~20:00',
    end: '20:00',
    xuanzhong: 0,
    key: 39
  }, {
    label: '20:00',
    value: '20:00~20:30',
    end: '20:30',
    xuanzhong: 0,
    key: 40
  }, {
    label: '20:30',
    value: '20:30~21:00',
    end: '21:00',
    xuanzhong: 0,
    key: 41
  }, {
    label: '21:00',
    value: '21:00~21:30',
    end: '21:30',
    xuanzhong: 0,
    key: 42
  }, {
    label: '21:30',
    value: '21:30~22:00',
    end: '22:00',
    xuanzhong: 0,
    key: 43
  }, {
    label: '22:00',
    value: '22:00~22:30',
    end: '22:30',
    xuanzhong: 0,
    key: 44
  }, {
    label: '22:30',
    value: '22:30~23:00',
    end: '23:00',
    xuanzhong: 0,
    key: 45
  }, {
    label: '23:00',
    value: '23:00~23:30',
    end: '23:30',
    xuanzhong: 0,
    key: 46
  }, {
    label: '23:30',
    value: '23:30~00:00',
    end: '00:00',
    xuanzhong: 0,
    key: 47
  }]
}
export default time